/* Sparkle Button - Particle Randomization Script */
(function() {
  function initSparkleParticles() {
    const RANDOM = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
    const PARTICLES = document.querySelectorAll('.sparkle-button .particle');
    
    PARTICLES.forEach(P => {
      // Only initialize if not already done
      if (!P.hasAttribute('data-sparkle-init')) {
        P.setAttribute('data-sparkle-init', 'true');
        P.setAttribute('style', `
          --x: ${RANDOM(20, 80)};
          --y: ${RANDOM(20, 80)};
          --duration: ${RANDOM(6, 20)};
          --delay: ${RANDOM(1, 10)};
          --alpha: ${RANDOM(40, 90) / 100};
          --origin-x: ${Math.random() > 0.5 ? RANDOM(300, 800) * -1 : RANDOM(300, 800)}%;
          --origin-y: ${Math.random() > 0.5 ? RANDOM(300, 800) * -1 : RANDOM(300, 800)}%;
          --size: ${RANDOM(40, 90) / 100};
        `);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSparkleParticles);
  } else {
    initSparkleParticles();
  }

  // Re-initialize when new content is added (for dynamic loading)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          initSparkleParticles();
        }
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Export for manual initialization
  window.initSparkleParticles = initSparkleParticles;
})();
